const defaultState = {
    report: {},
    error: null,
    fetching: false,
    fetched: false
};

const getPortfolioAuditReducer = (state = defaultState, action) => {
    switch (action.type) {
        case 'PORTFOLIO_AUDIT_CLEAR': {
            return {
                ...state, fetching: false, fetched: true, error: null, report: null
            };
        }
        case 'PORTFOLIO_AUDIT_FETCH_PENDING': {
            return {
                ...state, error: null, fetching: true, report: {}
            };
        }
        case 'PORTFOLIO_AUDIT_FETCH_FULFILLED': {
            return {
                ...state, fetching: false, fetched: true, error: null, report: action.payload.data
            };
        }
        case 'PORTFOLIO_AUDIT_FETCH_REJECTED': {
            return {
                ...state,
                fetching: false,
                fetched: false,
                report: {},
                error: action.payload
            };
        }
        default: {
            break;
        }
    }

    return state;
};

export default getPortfolioAuditReducer;


// WEBPACK FOOTER //
// ./src/reducers/getPortfolioAudit.js